
@if(shouldShowActionButton()){
  <evc-nav-button type="cta" size="xxl" variant="round" (click)="addTag()" *callToAction>
    <span class="top-cta-label">
      {{ 'commonLayout.newTag' | translate:{ tagLabel: "settingTenant.configuration_LabelOfTags" | translate } }}
    </span>
    <evc-svg-icon size="md" icon="plus"></evc-svg-icon>
  </evc-nav-button>
}
<mat-dialog-content>
  <div class="container" fxLayout="column">


    <div class="settings-title-container">
      <h1 >{{"settingTenant.configuration_LabelOfTags" | translate}}</h1>
    </div>

    <mat-table #table [dataSource]="tagListDataSource" class="tag-list"
      cdkDropList
      [cdkDropListData]="tagListDataSource"
      (cdkDropListDropped)="dropTable($event)">

      <!-- tag Column -->
      <ng-container matColumnDef="tags">
        <mat-header-cell *matHeaderCellDef>{{tagsLabel}}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index;" cdkDrag [cdkDragData]="row">
          <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" style="width: 100%;">
            <div class="tags-action-button">
              <mat-icon color="primary" class="table-column-property-panel-draggable tags-action-icon" cdkDragHandle>
                drag_indicator
              </mat-icon>
            </div>
            <mat-form-field>
              <input matInput [id]="idPrefix + i" [value]="rows[i]" [(ngModel)]="rows[i]" (blur)="submit()" maxlength="30">
              <mat-hint class="hint-error" align="start" *ngIf="requiredIdentifier(rows[i])">
                <font color="red">{{ 'settingsTagsEditDialog.tagError' | translate }}</font>
              </mat-hint>
              <mat-hint class="hint-error" align="center" *ngIf="rows[i].length > 0 && isRegularTextPattern(rows[i])">
                <font color="red">&nbsp;{{ 'settingsTagsEditDialog.tagMessage' | translate }}</font>
              </mat-hint>
              <mat-hint align="end">
                {{ rows[i].length || 0 }}/ 30
              </mat-hint>
            </mat-form-field>
            <button mat-button class="tags-action-button delete-tag"
                    (click)="deleteTags(i)"
              [disabled]="isDisableDeleteButton(i)" >
              <evc-svg-icon size="md" [icon]="'trash-can'"
                            class="black-icon"></evc-svg-icon></button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; let index = index; columns: displayedTagColumns;" (click)="selectTags(row, index)"
        [class.selected]="isSelectedTags(row, index)"></mat-row>
    </mat-table>
  </div>
</mat-dialog-content>
